import { JSX } from 'react'

import { IconProps } from '../../icon'

const Valores: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M35.993 34.311V13.7042H13.4577V33.8605H12.5562V11.9012H37.7957V33.8605L35.993 34.311Z'
      fill='#AAD3DC'
    />
    <path
      d='M15.7112 26.4865C15.7112 25.242 16.7202 24.233 17.9647 24.233C19.2092 24.233 20.2182 25.242 20.2182 26.4865C20.2182 27.731 19.2092 28.74 17.9647 28.74C16.7202 28.74 15.7112 27.731 15.7112 26.4865ZM23.3732 28.74C24.6177 28.74 25.6267 27.731 25.6267 26.4865C25.6267 25.242 24.6177 24.233 23.3732 24.233C22.1287 24.233 21.1197 25.242 21.1197 26.4865C21.1197 27.731 22.1287 28.74 23.3732 28.74ZM33.0977 28.6075C34.1762 27.9863 34.5467 26.6083 33.9255 25.53C33.3042 24.4518 31.9262 24.081 30.848 24.7023C29.7695 25.3235 29.399 26.7015 30.0202 27.7798C30.6415 28.8583 32.0195 29.2288 33.0977 28.6075Z'
      fill='#F9D865'
    />
    <path
      d='M40.0493 33.8597H10.5253V37.3035H40.0493V33.8597Z'
      fill='#D7D861'
    />
    <path
      d='M40.5 37.754H8.5V33.409H10.7535V11H38.2465V33.4097L40.5 33.409V37.754ZM9.4015 36.8528H39.5987V34.3105H9.4015V36.8528ZM36.4438 33.409H37.3452V11.9013H11.655V33.4095L12.5565 33.4088V12.8027H36.4438V33.409ZM13.4577 33.409H35.5422V13.704H27.819L31.0958 24.0962C31.6005 23.9215 32.1468 23.9008 32.6755 24.0435C33.373 24.231 33.9557 24.679 34.3162 25.3052C34.6768 25.9312 34.7722 26.66 34.5847 27.3575C34.3967 28.055 33.9487 28.6378 33.3228 28.9983C32.0295 29.7423 30.3742 29.297 29.63 28.0048C29.269 27.379 29.1737 26.6503 29.3615 25.9525C29.5138 25.386 29.8382 24.8955 30.2897 24.538L26.8738 13.7043H23.824V23.82C25.1012 24.0352 26.0775 25.149 26.0775 26.4865C26.0775 27.9778 24.8645 29.1908 23.3733 29.1908C21.882 29.1908 20.669 27.9778 20.669 26.4865C20.669 25.149 21.6452 24.0352 22.9225 23.82V13.7043H17.9648V23.82C19.242 24.0352 20.2183 25.149 20.2183 26.4865C20.2183 27.9778 19.0052 29.1908 17.514 29.1908C16.0227 29.1908 14.8098 27.9778 14.8098 26.4865C14.8098 25.149 15.786 24.0352 17.0632 23.82V13.7043H13.4577V33.409ZM31.97 24.8513C31.6585 24.8513 31.3507 24.933 31.073 25.0927C30.6558 25.3333 30.357 25.7217 30.232 26.1867C30.107 26.6517 30.1705 27.1378 30.4107 27.5548V27.555C30.9077 28.4163 32.012 28.7135 32.873 28.217C33.2902 27.9768 33.589 27.5883 33.714 27.1233C33.839 26.6583 33.7755 26.1722 33.5352 25.755C33.2945 25.3378 32.9062 25.039 32.441 24.914C32.2852 24.872 32.1272 24.8513 31.97 24.8513ZM23.3733 24.6837C22.3792 24.6837 21.5705 25.4925 21.5705 26.4865C21.5705 27.4805 22.3792 28.2893 23.3733 28.2893C24.3673 28.2893 25.176 27.4805 25.176 26.4865C25.176 25.4925 24.3673 24.6837 23.3733 24.6837ZM17.514 24.6837C16.52 24.6837 15.7112 25.4925 15.7112 26.4865C15.7112 27.4805 16.52 28.2893 17.514 28.2893C18.508 28.2893 19.3167 27.4805 19.3167 26.4865C19.317 25.4925 18.5083 24.6837 17.514 24.6837Z'
      fill='black'
    />
  </svg>
)

export default Valores
